import React from 'react';
import { Card, CardContent } from '../ui/card';
import { Target, CheckSquare, FolderOpen, Timer } from 'lucide-react';

function DashboardStats({ projectGroups, quickTasks }) {
  const totalProjects = projectGroups.reduce((acc, group) => acc + (group.projects?.length || 0), 0);

  const stats = [
    {
      title: 'Active Projects',
      value: totalProjects,
      icon: Target,
      gradient: 'from-red-500 to-red-600',
      iconColor: 'text-red-100'
    },
    {
      title: 'Recent Tasks',
      value: quickTasks.length,
      icon: CheckSquare,
      gradient: 'from-gray-600 to-gray-700',
      iconColor: 'text-gray-100'
    },
    {
      title: 'Project Groups',
      value: projectGroups.length,
      icon: FolderOpen,
      gradient: 'from-gray-800 to-gray-900',
      iconColor: 'text-gray-100'
    },
    {
      title: 'Focus Time',
      value: '0h',
      icon: Timer,
      gradient: 'from-red-600 to-red-700',
      iconColor: 'text-red-100'
    }
  ];

  return (
    <div className="grid grid-cols-1 md:grid-cols-4 gap-6 mb-8">
      {stats.map((stat, index) => {
        const IconComponent = stat.icon;
        return (
          <Card key={index} className={`bg-gradient-to-r ${stat.gradient} text-white border-0`}>
            <CardContent className="p-6">
              <div className="flex items-center justify-between">
                <div>
                  <p className="text-white/80 text-sm font-medium">{stat.title}</p>
                  <p className="text-2xl font-bold">{stat.value}</p>
                </div>
                <IconComponent className={`w-8 h-8 ${stat.iconColor}`} />
              </div>
            </CardContent>
          </Card>
        );
      })}
    </div>
  );
}

export default DashboardStats;
